import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { IoAdd, IoInformationCircleSharp } from 'react-icons/io5';
import { IoMdClose } from 'react-icons/io';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { BeatLoader } from 'react-spinners';
import toast, { Toaster } from 'react-hot-toast';
import { API } from '../../api/Api';
import { IoMdArrowBack } from "react-icons/io";
import { GrNext, GrPrevious } from 'react-icons/gr';
import { FaEdit } from 'react-icons/fa';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { FaCheck } from "react-icons/fa";
import { TiPinOutline } from "react-icons/ti";
import StyleTypeDropDown from '../components/Dropdowns/StyleTypeDropDown';
import Select, { components } from 'react-select';
import image1 from '../../assets/images/Base_01_Milk_Oak_Horizontal.png'
import image2 from '../../assets/images/Base_02_Bondi_Oak_Horizontal.png'
import image3 from '../../assets/images/Base_03_Pebble_Triba_Horizontal.png'
import image4 from '../../assets/images/Base_04_Ivory_Infinite_Oak_Horizontal_.png'
import image5 from '../../assets/images/Base_05_Ivory_Oak_Horizontal.png'
import { FaPlus } from "react-icons/fa6";
const OptionWithCheckbox = (props) => {
    return (
        <components.Option {...props}>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
                className="mr-2"
            />
            <label>{props.label}</label>
        </components.Option>
    );
};
const DetailsAgain = () => {
    const token = localStorage.getItem('token');

    const { id } = useParams();
    const location = useLocation();
    const { angleId } = location.state || {};

    const [activeFilter, setActiveFilter] = useState(null);

    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [apiDataforDropdown, setApiDataforDropdown] = useState([]);
    const [angleData, setAngleData] = useState([]);
    const [angles, setAngles] = useState([]);
    const [activeCategoryId, setActiveCategoryId] = useState(null);
    const [activeCategoryName, setActiveCategoryName] = useState('');
    const [previewImage, setPreviewImage] = useState(null);
    const [isImageModalOpen, setIsImageModalOpen] = useState(false);
    const [addCategoryLoading, setAddCategoryLoading] = useState(false);
    const [colorLoading, setColorLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showGallery, setShowGallery] = useState(false);
    const [colorToDelete, setColorToDelete] = useState(null);
    const [categoryLookup, setCategoryLookup] = useState({});

    const [showCategorySelector, setShowCategorySelector] = useState(false);
    const [categoryTabs, setCategoryTabs] = useState([]);
    const [dragTabs, setDragTabs] = useState([]); // used only for modal popup
    const [selectedDropdownCategoryId, setSelectedDropdownCategoryId] = useState('');
    const [categoryToDelete, setCategoryToDelete] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [orderUpdating, setOrderUpdating] = useState(false);
    const [defaultColorId, setDefaultColorId] = useState(null);
    const [inProgressRows, setInProgressRows] = useState([]);
    const [inSave, setSave] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);

    const [formData, setFormData] = useState({
        id: 0,
        name: '',
        visualizer_id: id,
        angle_id: '',
        visualizer_category_id: '',
        visualizer_style_type_id: '',
        is_default: '0',
        have_grain: '0',
        image: null,
        image_path: null,
        assets_color_thumbnail: null,
        assets_color_thumbnail_path: null,
        vertical_grain_image: null,
        vertical_grain_image_path: null,
        horizontal_grain_image: null,
        horizontal_grain_image_path: null,
        vertical_sequence_grain_image: null,
        vertical_sequence_grain_image_path: null,
        horizontal_sequence_grain_image: null,
        horizontal_sequence_grain_image_path: null,
        status: '1',
    });

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(20); // Number of items per page

    const resetFormData = () => {
        setFormData({
            id: 0,
            name: '',
            visualizer_id: id,
            angle_id: '',
            visualizer_category_id: '',
            visualizer_style_type_id: '',
            is_default: '0',
            have_grain: '0',
            image: null,
            image_path: null,
            assets_color_thumbnail: null,
            assets_color_thumbnail_path: null,
            vertical_grain_image: null,
            vertical_grain_image_path: null,
            horizontal_grain_image: null,
            horizontal_grain_image_path: null,
            vertical_sequence_grain_image: null,
            vertical_sequence_grain_image_path: null,
            horizontal_sequence_grain_image: null,
            horizontal_sequence_grain_image_path: null,
            status: '1',
        });

        setSelectedCategoryId('');
        setErrors({});
    };


    // const location = useLocation();
    const navigate = useNavigate();

    const [selectedAngle, setSelectedAngle] = useState("");
    const [popup, setPopup] = useState(false);
    const [addColorPopup, setAddColorPopup] = useState(false);

    const fetchVisualizerDetails = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizerdetail';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { visualizer_id: id };

        try {
            setLoading(true);
            const response = await API(url, requestBody, token);
            if (response) {
                setApiData(response.Result_value);
                setAngles(response.Result_value.VisualizerAngles);

                const availableAngles = response.Result_value.VisualizerAngles;

                if (availableAngles.length > 0) {
                    const defaultAngle = angleId && availableAngles.some(a => a.id === angleId)
                        ? angleId
                        : availableAngles[0].id;

                    setSelectedAngle(defaultAngle);
                    fetchAngleData(defaultAngle);
                }
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {
            setLoading(false);
        }
    };


    const fetchCategoryList = async () => {
        const baseURl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getvisualizermasterlist';
        const url = `${baseURl}${apiPath}`;
        const requestBody = { type: "category" };

        try {
            setLoading(true);
            const response = await API(url, requestBody, token);
            if (response) {
                setApiDataforDropdown(response.Data);
            }
        } catch (error) {
            console.error('Error during authentication:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchVisualizerDetails();
        fetchCategoryList();
    }, []);

    useEffect(() => {
        const categoryMap = {};

        apiDataforDropdown?.forEach((parent) => {
            categoryMap[parent.id] = parent.name;

            parent.ChildCategory?.forEach((child) => {
                categoryMap[child.id] = child.name;
            });
        });

        setCategoryLookup(categoryMap);
    }, [apiDataforDropdown]);


    useEffect(() => {
        if (apiData?.VisualizerCategory) {
            setCategoryTabs(apiData.VisualizerCategory);
        }
    }, [apiData]);

    const handleDragEnd = async (result) => {
        if (!result.destination) return;

        const reordered = Array.from(dragTabs);
        const [moved] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, moved);

        setDragTabs(reordered);

        const payload = {
            visualizer_id: parseInt(id),
            category: reordered.map((cat) => String(cat.category_id)),
        };


        try {
            setOrderUpdating(true);

            const url = `https://be-visualizer-tool-887aa0e11caa.herokuapp.com/api/visualizer/changevisualizercategoryorder`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            }).then((res) => res.json());


            if (response?.Result === 1) {
                toast.success("Order updated");
            } else {
                toast.error("Failed to update order");
            }
        } catch (err) {
            console.error(" Order update error:", err);
            toast.error("Something went wrong");
        } finally {
            setOrderUpdating(false);
        }
    };



    const handleRemoveTab = (id) => {
        const filtered = dragTabs.filter((tab) => tab.category_id !== id);
        setDragTabs(filtered);
    };





    useEffect(() => {
        if (apiData?.VisualizerCategory?.length > 0) {
            const defaultCat = apiData.VisualizerCategory[0];
            setActiveCategoryId(defaultCat.category_id);
            setActiveCategoryName(defaultCat.VisualizerMasterCategory?.name || '');
        }
    }, [apiData]);



    const [errors, setErrors] = useState({});
    const [selectedCategoryId, setSelectedCategoryId] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const val = type === 'checkbox' ? (checked ? '1' : '0') : value;
        setFormData({
            ...formData,
            [name]: val,
        });


        // Clear error when user starts typing
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const { name } = e.target;
        setFormData({
            ...formData,
            [name]: file,
        });
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: undefined,
        }));
    };


    const handleSubCategory = (e) => {
        const selectedCategoryId = e.target.value;

        setSelectedCategoryId(selectedCategoryId); // for UI dropdown control

        setFormData((prev) => ({
            ...prev,
            visualizer_category_id: selectedCategoryId, // 🔥 This ensures it is sent in the payload
        }));

    };
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedAngles, setSelectedAngles] = useState([]);
    const staticCategories = [
        "Base Cabinets",
        "Wall Cabinets",
        "Island Cabinets",
        "Tall Cabinets",
        "Appliances",
        "Backsplash",
        "Countertop",
        "Flooring",
        "Celling",
    ];
    const galleryImages = [
        {
            url: formData.image || image1,
            categories: ["Base Cabinets", "Countertop"],
            angles: ["Angle 1"],
            name: ["Base_01_Milk_Oak_Vertical"]
        },
        {
            url: formData.vertical_grain_image_path || image2,
            categories: ["Wall Cabinets", "Flooring"],
            angles: ["Angle 2"],
            name: ["Base_02_Bondi_Oak_Horizontal"]
        },
        {
            url: formData.horizontal_grain_image_path || image3,
            categories: ["Appliances"],
            angles: ["Angle 1"],
            name: ["Base_03_Pebble_Triba_Vertical_Sequence"]
        },
        {
            url: formData.horizontal_grain_image_path || image4,
            categories: ["Flooring", "Celling"],
            angles: ["Angle 2"],
            name: ["Base_04_lvory_Infinite_Oak_Horizontal_Sequence"]
        },

    ];

    const handleAngleChange = (e) => {
        const angleId = e.target.value;
        setSelectedAngle(angleId);
        fetchAngleData(angleId);
    };

    const fetchAngleData = async (angleId) => {
        const baseUrl = process.env.REACT_APP_API_URL;
        const apiPath = '/visualizer/getangledetail'; // Replace with your actual API endpoint
        const url = `${baseUrl}${apiPath}`;
        const requestBody = { angle_id: angleId };

        try {
            setColorLoading(true);
            const response = await API(url, requestBody, token);
            if (response) {
                // Handle the response data as needed
                // Update state with the fetched data
                setAngleData(response.Result_value);
            }
        } catch (error) {
            console.error('Error fetching angle data:', error);
        } finally {
            setColorLoading(false);
        }
    };

    const filteredColors = angleData?.VisualizerAngleAssetsColor
        ?.filter(color => color.VisualizerAssetColorCategories?.parent_id === activeCategoryId)
        ?.filter(color => color.name.toLowerCase().includes(searchQuery.toLowerCase()));


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredColors?.slice(indexOfFirstItem, indexOfLastItem);

    //const totalPages = Math.ceil(filteredColors?.length / itemsPerPage);
    const totalPages = '1';

    // ADD COLORS LOGIC




    const validateForm = () => {
        const errors = {};

        if (!formData.name?.trim()) {
            errors.name = 'Color name is required';
        }

        if (!formData.visualizer_category_id) {
            errors.visualizer_category_id = 'Subcategory is required';
        }
        if (!formData.visualizer_style_type_id) {
            errors.visualizer_style_type_id = 'Style Type is required';
        }

        if (!formData.assets_color_thumbnail && !formData.assets_color_thumbnail_path) {
            errors.assets_color_thumbnail = 'Thumbnail is required';
        }


        if (formData.have_grain === '0') {
            if (!formData.image && !formData.image_path) {
                errors.image = 'Image is required when grain is disabled';
            }
        } else {
            if (!formData.vertical_grain_image && !formData.vertical_grain_image_path) {
                errors.vertical_grain_image = 'Vertical grain image is required';
            }
            if (!formData.horizontal_grain_image && !formData.horizontal_grain_image_path) {
                errors.horizontal_grain_image = 'Horizontal grain image is required';
            }
            if (!formData.vertical_sequence_grain_image && !formData.vertical_sequence_grain_image_path) {
                errors.vertical_sequence_grain_image = 'Vertical sequence grain image is required';
            }
            if (!formData.horizontal_sequence_grain_image && !formData.horizontal_sequence_grain_image_path) {
                errors.horizontal_sequence_grain_image = 'Horizontal sequence grain image is required';
            }
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const handleSubmitColorData = async () => {
        if (!validateForm()) {
            toast.error('Please fill all the fields');
            return;
        }

        const form = new FormData();

        // Append the necessary parameters
        form.append('id', formData.id);
        form.append('name', formData.name);
        form.append('visualizer_id', id);
        form.append('key', apiData.key);
        form.append('angle_id', selectedAngle);
        form.append('visualizer_category_id', formData.visualizer_category_id);
        form.append('visualizer_style_type_id', formData.visualizer_style_type_id);
        form.append('is_default', 0);
        form.append('have_grain', formData.have_grain);
        form.append('status', formData.status);

        // Always required images
        if (formData.assets_color_thumbnail instanceof File) {
            form.append('assets_color_thumbnail', formData.assets_color_thumbnail);
            form.append('assets_color_thumbnail_path', '');
        } else {
            form.append('assets_color_thumbnail', '');
            form.append('assets_color_thumbnail_path', formData.assets_color_thumbnail_path || '');
        }


        // Conditionally required if grain is enabled
        if (formData.have_grain === '1') {
            if (formData.vertical_grain_image instanceof File) {
                form.append('vertical_grain_image', formData.vertical_grain_image);
                form.append('vertical_grain_image_path', '');
            } else {
                form.append('vertical_grain_image', '');
                form.append('vertical_grain_image_path', formData.vertical_grain_image_path || '');
            }
            if (formData.horizontal_grain_image instanceof File) {
                form.append('horizontal_grain_image', formData.horizontal_grain_image);
                form.append('horizontal_grain_image_path', '');
            } else {
                form.append('horizontal_grain_image', '');
                form.append('horizontal_grain_image_path', formData.horizontal_grain_image_path);
            }
            if (formData.vertical_sequence_grain_image instanceof File) {
                form.append('vertical_sequence_grain_image', formData.vertical_sequence_grain_image);
                form.append('vertical_sequence_grain_image_path', '');
            } else {
                form.append('vertical_sequence_grain_image', '');
                form.append('vertical_sequence_grain_image_path', formData.vertical_sequence_grain_image_path);
            }
            if (formData.horizontal_sequence_grain_image instanceof File) {
                form.append('horizontal_sequence_grain_image', formData.horizontal_sequence_grain_image);
                form.append('horizontal_sequence_grain_image_path', '');
            } else {
                form.append('horizontal_sequence_grain_image', '');
                form.append('horizontal_sequence_grain_image_path', formData.horizontal_sequence_grain_image_path);
            }
            form.append('image', null);
            form.append('image_path', null);
        } else {
            form.append('vertical_grain_image', null);
            form.append('vertical_grain_image_path', null);
            form.append('horizontal_grain_image', null);
            form.append('horizontal_grain_image_path', null);
            form.append('vertical_sequence_grain_image', null);
            form.append('vertical_sequence_grain_image_path', null);
            form.append('horizontal_sequence_grain_image', null);
            form.append('horizontal_sequence_grain_image_path', null);
            if (formData.image instanceof File) {
                form.append('image', formData.image);
                form.append('image_path', '');
            } else {
                form.append('image', '');
                form.append('image_path', formData.image_path);
            }

        }

        // console.log("🚀 SUBMITTING COLOR PAYLOAD:");
        // for (let pair of form.entries()) {
        //     console.log(`${pair[0]}:`, pair[1]);
        // }

        // if (formData.have_grain === '0') {
        //     if (!formData.image && formData.image_path == null) {
        //         errors.image = 'Image is required';
        //         toast.error("Image is required")
        //         return;
        //     }
        // } else {
        //     if (!formData.vertical_grain_image && !formData.vertical_grain_image_path) {
        //         errors.vertical_grain_image = 'vertical_grain_image is required';
        //         toast.error("vertical_grain_image is required")
        //         return;
        //     }
        // if (!formData.horizontal_grain_image && formData.horizontal_grain_image_path == null) {
        //     errors.horizontal_grain_image = 'horizontal_grain_image is required';
        //     toast.error("horizontal_grain_image is required")
        //     return;
        // }
        // if (!formData.vertical_sequence_grain_image && formData.vertical_sequence_grain_image_path == null) {
        //     errors.vertical_sequence_grain_image = 'vertical_sequence_grain_image is required';
        //     toast.error("vertical_sequence_grain_image is required")
        //     return;
        // }
        // if (!formData.horizontal_sequence_grain_image && formData.horizontal_sequence_grain_image_path == null) {
        //     errors.horizontal_sequence_grain_image = 'horizontal_sequence_grain_image is required';
        //     toast.error("horizontal_sequence_grain_image is required")
        //     return;
        // }
        // }


        try {

            setSubmitLoading(true);
            const url = `${process.env.REACT_APP_API_URL}/visualizer/createupdatevisualizercolor`;
            const response = await API(url, form, token);

            if (response?.Result == 1) {
                toast.success(formData.id ? 'Color updated successfully!' : 'Color added successfully!');
                await fetchVisualizerDetails();
                resetFormData();
                setAddColorPopup(false);
            } else {
                toast.error(formData.id ? 'Failed to update color' : 'Failed to add color');
            }
        } catch (error) {
            console.error('Add Color Error:', error);
            toast.error('Something went wrong');
        } finally {
            setSubmitLoading(false);
        }
    };

    const parentCategories = apiDataforDropdown || [];

    const dropdownOptions = parentCategories.filter(
        (cat) => !dragTabs.some((tab) => tab.category_id === cat.id)
    );


    const handleAddCategoryAPI = async () => {
        const selectedCat = dropdownOptions.find(
            (cat) => cat.id === parseInt(selectedDropdownCategoryId)
        );

        if (!selectedCat) return;

        const payload = {
            visualizer_id: parseInt(id),
            category_id: selectedCat.id,
            order: dragTabs.length + 1, // or adjust logic as needed
            status: "1",
        };

        try {
            setAddCategoryLoading(true);
            const url = `${process.env.REACT_APP_API_URL}/visualizer/assign-category`;
            const response = await API(url, payload, token);

            if (response?.Result === 1) {
                fetchVisualizerDetails();
                toast.success("Category added successfully");

                // Update dragTabs with the new category
                setDragTabs((prev) => [
                    ...prev,
                    {
                        id: selectedCat.id,
                        category_id: selectedCat.id,
                        VisualizerMasterCategory: {
                            id: selectedCat.id,
                            name: selectedCat.name,
                        },
                    },
                ]);

                // Also update main category tabs if needed
                setCategoryTabs((prev) => [
                    ...prev,
                    {
                        id: selectedCat.id,
                        category_id: selectedCat.id,
                        VisualizerMasterCategory: {
                            id: selectedCat.id,
                            name: selectedCat.name,
                        },
                    },
                ]);

                setSelectedDropdownCategoryId('');
            } else {
                toast.error("Failed to add category");
            }
        } catch (error) {
            console.error("Add category error:", error);
            toast.error("Something went wrong");
        } finally {
            setAddCategoryLoading(false);
        }
    };

    const handleSetDefault = async (colorId, angleId) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/visualizer/makedefault`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    id: colorId,
                    parent_category_id: activeCategoryId,
                    angle_id: angleId,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setDefaultColorId(colorId);
                fetchAngleData(angleId);
                toast.success("Default color set successfully!");
            } else {
                toast.error(data?.message || "Failed to set default color");
            }
        } catch (error) {
            console.error("API error:", error);
            toast.error("An error occurred while setting default color.");
        }
    };

    const handleStyleTypeSelect = (default_style_type_id) => {
        setFormData((prevData) => ({
            ...prevData,
            visualizer_style_type_id: default_style_type_id || "",
        }));
    };

    // Helper to give each item categories (fake or real later)
    const getItemCategories = (item) => {
        if (item.categories && item.categories.length > 0) {
            return item.categories; // ✅ real API categories
        }

        // fallback: assign 2–3 static categories consistently
        const index = item.id % staticCategories.length;

        // always return at least 2 categories
        const categories = [
            staticCategories[index],
            staticCategories[(index + 1) % staticCategories.length],
        ];

        // give some rows a 3rd category
        if (item.id % 2 === 0) {
            categories.push(staticCategories[(index + 2) % staticCategories.length]);
        }

        return categories;
    };


    // Apply filter
    const filteredItems = (
        activeFilter
            ? (currentItems || []).filter((item) =>
                (getItemCategories(item) || []).includes(activeFilter)
            )
            : (currentItems || [])
    ).map((item, index) => {
        let saveStatus = "selectable"; // default

        if (index === 0) saveStatus = "inProgress";
        if (index === 1) saveStatus = "saved";
        if (index === 2) saveStatus = "rendered";

        return {
            ...item,
            saveStatus,
        };
    });




    const uniqueCategories = Array.from(
        new Map(
            Object.entries(categoryLookup).map(([key, value]) => [value, { value: key, label: value }])
        ).values()
    );

    // skip first 7 and keep the rest
    const brandOptions = uniqueCategories.slice(7);

    const styleTypeOptions = [
        { id: 1, name: "Slab" },
        { id: 2, name: "Shaker" },

    ];

    const brandeOptions = [
        { id: 1, name: "Shinnoki" },
        { id: 2, name: "AGT" },

    ];


    const handleReRenderRow = (id) => {
        if (window.confirm("Do you want to re-render this color?")) {
            setInProgressRows(prev => [...prev, id]);


        }
    };

    const handleSelectRow = (id) => {
        setSelectedRows(prev =>
            prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedRows([]);
        } else {
            setSelectedRows(filteredItems.map(item => item.id));
        }
        setSelectAll(!selectAll);
    };

    const handleBulkReRender = () => {
        if (selectedRows.length === 0) {
            alert("Please select at least one row.");
            return;
        }
        if (window.confirm("Re-render selected rows?")) {
            setInProgressRows(prev => [...prev, ...selectedRows]);


        }
    };

    return (
        <>
            {loading || submitLoading || deleteLoading || orderUpdating || addCategoryLoading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/80">
                    <BeatLoader size={20} />
                </div>
            )}

            {submitLoading && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <BeatLoader color="#fff" size={12} />
                </div>
            )}

            <Toaster position="top-center" />
            <div className="flex h-screen fixed w-full">
                <div className="md:w-64 w-16 bg-black transition-all">
                    <Sidebar />
                </div>
                <div className="flex flex-col flex-1 min-h-full">
                    <div className="bg-gray-100 flex-1 p-4 overflow-auto min-h-full">
                        <div className="bg-white rounded-2xl w-full flex flex-col min-h-full">
                            {/* Header Section */}
                            <div className="flex justify-between items-center px-6 pt-4">
                                <div>
                                    <p className="text-teal-500 text-xl font-semibold flex items-center gap-3">
                                        {apiData?.name} Layout
                                        {/*} <span>
                                            <IoInformationCircleSharp
                                                onClick={() => setPopup(true)}
                                                color='red'
                                                className='cursor-pointer'
                                            />
                                        </span>*/}
                                    </p>
                                    <p className="text-gray-600 mb-4">
                                        <span className="text-teal-500">
                                            <Link to="/admin/layouts" className="hover:text-teal-600 transition">Layout</Link>
                                        </span>
                                        <span className="text-gray-500"> / Details</span>
                                    </p>
                                </div>

                                <IoMdArrowBack
                                    style={{ width: "32px", height: "32px", color: "gray", cursor: "pointer" }}
                                    title="Back"
                                    onClick={() => navigate('/admin/layouts')}
                                />

                            </div>
                            <hr className="border-gray-200" />

                            {/* Details Section */}
                            <div className="bg-white rounded-2xl w-full h-full px-4 flex-1 flex flex-col justify-between">
                                <div className="mb-4 flex-1">
                                    <div className="mx-auto text-xs md:text-base">
                                        {/* Angle Dropdown 
                                        <div className="p-6">
                                            <p className="text-xl font-semibold text-teal-500 mb-4">Select Angle</p>
                                            <div className="relative z-0 w-full max-w-xs mb-1 group">
                                                <select
                                                    id="angle"
                                                    name="angle"
                                                    value={selectedAngle}
                                                    onChange={handleAngleChange}
                                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border rounded-lg border-gray-300 appearance-none focus:outline-none border-b peer"
                                                >
                                                    <option value="" disabled>Select Angle</option>
                                                    {angles.map((angle) => (
                                                        <option key={angle.id} value={angle.id}>
                                                            {angle.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>*/}

                                        {/* Tabs for Categories */}
                                        <div className="p-6">
                                            {/* <p className="text-xl font-semibold text-teal-500 mb-4">Visualizer Categories</p> */}
                                            <div className="flex justify-between items-center mb-4">
                                                <p className="text-xl font-semibold text-teal-500">Filters</p>
                                                {/*<button
                                                    onClick={() => {
                                                        setDragTabs([...categoryTabs]); // clone so drag doesn't mutate original
                                                        setShowCategorySelector(true);
                                                    }}

                                                    className="text-teal-500 bg-green-500 rounded hover:text-teal-700 text-2xl"
                                                    title="Add Category"
                                                >
                                                    <IoAdd color='white' size={25} />
                                                </button>*/}
                                            </div>

                                            <div className="flex flex-wrap gap-2">
                                                {staticCategories.map((cat) => (
                                                    <div
                                                        key={cat}
                                                        onClick={() =>
                                                            setActiveFilter(activeFilter === cat ? null : cat) // toggle filter
                                                        }
                                                        className={`cursor-pointer px-4 py-2 rounded text-sm font-medium shadow transition 
                                                              ${activeFilter === cat
                                                                ? "bg-blue-600 text-white"
                                                                : "bg-blue-100 text-blue-700 hover:bg-blue-200"
                                                            }`}
                                                    >
                                                        {cat}
                                                    </div>
                                                ))}
                                            </div>
                                            <hr className="text-gray-200 my-2" />



                                            {/* Add Color Button 
                                            <div className="flex justify-between items-center mt-4">
                                                <div className="flex items-center gap-4">
                                                    {/* Select All 
                                                    <label className="flex items-center gap-2">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectAll}
                                                            onChange={handleSelectAll}
                                                        />
                                                        Select All
                                                    </label>

                                                    {/* Show Re-render only if any checkbox is selected
                                                    {(selectedRows.length > 0 || selectAll) && (
                                                        <button
                                                            onClick={handleBulkReRender}
                                                            className="bg-gradient-to-r from-teal-400 to-teal-500 text-white px-3 py-1 rounded hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                                        >
                                                            ♻️ Re-render
                                                        </button>
                                                    )}
                                                </div>

                                                <div className="mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Search by color name..."
                                                        value={searchQuery}
                                                        onChange={(e) => setSearchQuery(e.target.value)}
                                                        className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500"
                                                    />
                                                </div>




                                                <button
                                                    onClick={() => setAddColorPopup(true)}
                                                    className="flex items-center gap-2 bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded-lg px-3 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                                >
                                                    <FaPlus className="text-lg" />
                                                    Add Color
                                                </button>

                                            </div>*/}

                                            {/* Table View */}
                                            <div className="overflow-x-auto">



                                                <table className="w-full mt-4 border-collapse bg-white rounded-lg shadow-md">
                                                    <thead className="bg-gray-100 text-gray-800">
                                                        <tr>
                                                            <th className="p-3 text-start"></th>
                                                            <th className="p-3 text-start">Thumbnail</th>
                                                            <th className="p-3 text-start">Color Name</th>
                                                            <th className="p-3 text-start">Default</th>
                                                            <th className="p-3 text-start">Category</th>
                                                            <th className="p-3 text-start">Style Name</th>
                                                            <th className="p-3 text-start">Status</th>
                                                            {/*<th className="p-3 text-start">Actions</th>*/}
                                                        </tr>
                                                    </thead>

                                                    {colorLoading ? (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="9">
                                                                    <div className="flex m-auto justify-center items-center py-8">
                                                                        <BeatLoader color="#14b8a6" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ) : filteredItems?.length > 0 ? (
                                                        <tbody>
                                                            {filteredItems.map((item, index) => {
                                                                const isInProgress = index < 2 || inProgressRows.includes(item.id);

                                                                 const save = index === 2 || inSave.includes(item.id);
                                                                return (
                                                                    <tr
                                                                        key={item.id}
                                                                        className={`${item.status ? "border-b hover:bg-gray-50" : "bg-gray-300"} 
                                                                 ${isInProgress ? "opacity-50 cursor-not-allowed" : ""}`}
                                                                    >



                                                                        {/* Index */}

                                                                        <td className="p-3">
                                                                           {isInProgress ? (
  // In Progress Spinner
  <span className="flex items-center gap-2 text-gray-500">
    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8z"
      />
    </svg>
    In Progress
  </span>
) : save ? (
  // Rendered icon if save condition true
  <></>
) : (
  <></>
)}
                                                                        </td>

                                                                        {/* Thumbnail / In-progress */}
                                                                        <td className="p-3">

                                                                            <img
                                                                                src={item.assets_color_thumbnail}
                                                                                alt="thumbnail"
                                                                                className="w-14 h-auto cursor-pointer rounded shadow"
                                                                                onClick={() => {
                                                                                    setPreviewImage(item.assets_color_thumbnail);
                                                                                    setIsImageModalOpen(true);
                                                                                }}
                                                                            />

                                                                        </td>

                                                                        {/* Color name (disabled if in progress) */}
                                                                        <td
                                                                            className={`p-3 ${isInProgress
                                                                                ? "text-gray-400"
                                                                                : "cursor-pointer text-blue-600 hover:underline"
                                                                                }`}
                                                                            onClick={() => {
                                                                                if (!isInProgress) {
                                                                                    setFormData(prev => ({ ...prev, selectedColor: item }));
                                                                                    setShowGallery(true);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {item.name}
                                                                        </td>

                                                                        {/* Default pin */}
                                                                        <td className="p-3">
                                                                            {item.StyleType &&
                                                                                item.StyleType.id === item.visualizer_style_type_id &&
                                                                                item.StyleType.name === "Slab" &&
                                                                                (item.is_default === true || item.is_default === "true" ? (
                                                                                    <span className="text-green-600 font-semibold bg-gray-300 inline-flex items-center justify-center px-2 py-1 rounded">
                                                                                        <TiPinOutline color="grey" />
                                                                                    </span>
                                                                                ) : (
                                                                                    <button
                                                                                        onClick={() => handleSetDefault(item.id, item.angle_id)}
                                                                                        className="text-sm text-white bg-teal-500 hover:bg-teal-600 px-3 py-1 rounded"
                                                                                    >
                                                                                        <TiPinOutline />
                                                                                    </button>
                                                                                ))}
                                                                        </td>

                                                                        {/* Categories */}
                                                                        <td className="p-3">
                                                                            <div className="flex flex-wrap gap-2">
                                                                                {getItemCategories(item).map((cat, idx) => (
                                                                                    <span
                                                                                        key={idx}
                                                                                        className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded"
                                                                                    >
                                                                                        {cat}
                                                                                    </span>
                                                                                ))}
                                                                            </div>
                                                                        </td>

                                                                        {/* Style name */}
                                                                        <td className="p-3">{item?.StyleType?.name}</td>

                                                                        {/* Status checkbox */}
                                                                        <td className="p-3">
                                                                            <button
                                                                                onClick={() => {
                                                                                    setAngleData(prev => ({
                                                                                        ...prev,
                                                                                        VisualizerAngleAssetsColor: prev.VisualizerAngleAssetsColor.map(color =>
                                                                                            color.id === item.id
                                                                                                ? { ...color, status: !color.status }
                                                                                                : color
                                                                                        )
                                                                                    }));
                                                                                }}
                                                                                className={`px-3 py-1 rounded text-white text-sm font-medium ${item.status ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"
                                                                                    }`}
                                                                            >
                                                                                {item.status ? "Active" : "Inactive"}
                                                                            </button>
                                                                        </td>


                                                                        {/* Actions */}
                                                                        {/* <td className="p-3 flex gap-2 mt-3">
                                                                            <button
                                                                                className={`hover:underline ${isInProgress ? "text-gray-400 cursor-not-allowed" : "text-blue-500"
                                                                                    }`}
                                                                                title="Edit Color"
                                                                                disabled={isInProgress}
                                                                                onClick={() => {
                                                                                    const data = item;
                                                                                    setFormData({
                                                                                        id: data.id,
                                                                                        name: data.name || "",
                                                                                        visualizer_id: data.visualizer_id,
                                                                                        angle_id: data.angle_id,
                                                                                        visualizer_category_id: data.visualizer_category_id,
                                                                                        is_default: data.is_default ? "1" : "0",
                                                                                        have_grain: data.have_grain ? "1" : "0",
                                                                                        status: data.status ? "1" : "0",
                                                                                        assets_color_thumbnail: null,
                                                                                        assets_color_thumbnail_path: data.assets_color_thumbnail || "",
                                                                                        image: null,
                                                                                        image_path: data.image || "",
                                                                                        vertical_grain_image: null,
                                                                                        vertical_grain_image_path: data.vertical_grain_image || "",
                                                                                        horizontal_grain_image: null,
                                                                                        horizontal_grain_image_path: data.horizontal_grain_image || "",
                                                                                        vertical_sequence_grain_image: null,
                                                                                        vertical_sequence_grain_image_path: data.vertical_sequence_grain_image || "",
                                                                                        horizontal_sequence_grain_image: null,
                                                                                        horizontal_sequence_grain_image_path: data.horizontal_sequence_grain_image || ""
                                                                                    });
                                                                                    setSelectedCategoryId(data.visualizer_category_id);
                                                                                    setAddColorPopup(true);
                                                                                }}
                                                                            >
                                                                                <FaEdit size={20} />
                                                                            </button>

                                                                            {/* Delete */}
                                                                        {/*<button
                                                                                title="Delete Color"
                                                                                className={`hover:underline ${isInProgress ? "text-gray-400 cursor-not-allowed" : "text-red-500"
                                                                                    }`}
                                                                                disabled={isInProgress}
                                                                                onClick={() => {
                                                                                    setColorToDelete(item.id);
                                                                                    setShowDeleteModal(true);
                                                                                }}
                                                                            >
                                                                                <MdOutlineDeleteOutline size={20} />
                                                                            </button>

                                                                            {/* Re-render */}
                                                                        {/* <button
                                                                                className={` ${isInProgress ? "text-gray-400 cursor-not-allowed" : "text-purple-500"
                                                                                    }`}
                                                                                title="Re-render Row"
                                                                                disabled={isInProgress}
                                                                                onClick={() => handleReRenderRow(item.id)}
                                                                            >
                                                                                ♻️
                                                                            </button>
                                                                        </td>*/}
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    colSpan="9"
                                                                    className="py-12 text-lg text-center text-gray-500"
                                                                >
                                                                    No colors found for this category.
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}
                                                </table>


                                            </div>
                                            {currentItems?.length > 0 && (
                                                <div className="flex justify-center items-center gap-4 mt-4">
                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                        disabled={currentPage === 1}
                                                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                                    >
                                                        <GrPrevious />
                                                    </button>

                                                    <span className="text-gray-700">
                                                        Page {currentPage} of {totalPages}
                                                    </span>

                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                        disabled={currentPage === totalPages}
                                                        className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 disabled:opacity-50"
                                                    >
                                                        <GrNext />
                                                    </button>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Visualizer Details Popup Modal */}
                {popup && (
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
                        <div className="relative bg-white rounded-2xl p-6 w-[50%] max-h-[80vh] overflow-y-auto shadow-lg">
                            {apiData ? (
                                <>
                                    {/* Modal Header */}
                                    < div className="flex justify-between items-center mb-4">
                                        <p className="text-teal-500 text-xl font-semibold">Visualizer Details</p>
                                        <button
                                            onClick={() => setPopup(false)}
                                            className="bg-gradient-to-r from-teal-400 to-teal-500 text-white rounded px-4 py-2 hover:from-teal-500 hover:to-teal-600 transition shadow-md"
                                        >
                                            Close
                                        </button>
                                    </div>
                                    <hr className="border-gray-200 mb-4" />

                                    {/* Modal Content */}
                                    <div className="grid grid-cols-2 md:grid-cols-2 gap-6 m-4">
                                        {/* <div className="flex items-center space-x-2">
                                            <span className="text-gray-500 text-sm font-medium">ID:</span>
                                            <span className="text-gray-900 text-sm">{apiData.id}</span>
                                        </div> */}
                                        <div className="flex items-center space-x-2 m-4">
                                            <span className="text-gray-500 text-sm font-medium">Name:</span>
                                            <span className="text-gray-900 text-sm">{apiData.name}</span>
                                        </div>
                                        <div className="flex items-center space-x-2 m-4">
                                            <span className="text-gray-500 text-sm font-medium">Key:</span>
                                            <span className="text-gray-900 text-sm">{apiData.key}</span>
                                        </div>
                                        {/* <div className="flex items-center space-x-2">
                                            <span className="text-gray-500 text-sm font-medium">Status:</span>
                                            <span className="text-gray-900 text-sm">{apiData.status === true ? 'Active' : 'InActive'}</span>
                                        </div> */}
                                        <div className="flex items-center space-x-2 m-4">
                                            <span className="text-gray-500 text-sm font-medium">Contact Name:</span>
                                            <span className="text-gray-900 text-sm">{apiData.contact_person_name || "N/A"}</span>
                                        </div>
                                        <div className="flex items-center space-x-2 m-4">
                                            <span className="text-gray-500 text-sm font-medium">Contact Email:</span>
                                            <span className="text-gray-900 text-sm">{apiData.contact_person_email || "N/A"}</span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <p>Not Found</p>
                            )}
                        </div>
                    </div>
                )}

                {/* Add Color Popup Modal */}
                {addColorPopup && (
                    <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-75">
                        <div className="bg-white p-6 h-[90%] w-3/4 md:w-[70%] shadow-lg ">
                            <h2 className="text-2xl font-bold mb-6 text-center">
                                {formData.id ? `Edit  Color` : `Add  Color`}
                            </h2>

                            <div className='h-[80%] p-2 overflow-auto'>

                                <div className="flex-1 ">
                                    <div className="grid grid-cols-1 md:grid-cols-[5fr,5fr,2fr] gap-6">

                                        <div className="mb-6 p-5 pl-3 ml-5">
                                            <label htmlFor="name" className="block text-sm font-semibold mb-2 text-gray-700">Color Name<span className="text-red-500">*</span></label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"

                                                placeholder="Enter Color Name"
                                            />
                                            {errors.name && <p className="text-red-500 text-xs italic mt-2">{errors.name}</p>}
                                        </div>

                                        <div className="mb-6  p-5 pl-3 ml-5">
                                            <label className="block text-sm font-semibold mb-3 text-gray-700">
                                                Status <span className="text-red-500">*</span>
                                            </label>

                                            <div className="flex gap-4">
                                                {/* Active */}
                                                <label
                                                    className={`cursor-pointer flex items-center justify-center px-6 py-2 rounded-full border-2 text-sm font-medium transition
                                                       ${formData.status === '1'
                                                            ? "bg-green-100 border-green-500 text-green-700 shadow-md"
                                                            : "border-gray-300 text-gray-500 hover:bg-gray-100"}`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="status"
                                                        value="1"
                                                        checked={formData.status === '1'}
                                                        onChange={handleChange}
                                                        className="hidden"
                                                    />
                                                    Active
                                                </label>

                                                {/* Inactive */}
                                                <label
                                                    className={`cursor-pointer flex items-center justify-center px-6 py-2 rounded-full border-2 text-sm font-medium transition
                                                         ${formData.status === '0'
                                                            ? "bg-red-100 border-red-500 text-red-700 shadow-md"
                                                            : "border-gray-300 text-gray-500 hover:bg-gray-100"}`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="status"
                                                        value="0"
                                                        checked={formData.status === '0'}
                                                        onChange={handleChange}
                                                        className="hidden"
                                                    />
                                                    Inactive
                                                </label>
                                            </div>
                                        </div>


                                        <div className="mb-6 p-5 pl-3 ml-5">
                                            <label className="block text-sm font-semibold mb-3 text-gray-700">
                                                Is Re-render <span className="text-red-500">*</span>
                                            </label>

                                            <div className="flex items-center gap-3">
                                                <span
                                                    className={`text-sm font-medium ${formData.rerender === "1" ? "text-green-600" : "text-gray-500"
                                                        }`}
                                                >
                                                    {formData.rerender === "1" ? "Yes" : "No"}
                                                </span>

                                                <button
                                                    type="button"
                                                    onClick={() =>
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            rerender: prev.rerender === "1" ? "0" : "1",
                                                        }))
                                                    }
                                                    className={`relative inline-flex h-6 w-12 items-center rounded-full transition ${formData.rerender === "1" ? "bg-green-500" : "bg-gray-300"
                                                        }`}
                                                >
                                                    <span
                                                        className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${formData.rerender === "1" ? "translate-x-6" : "translate-x-1"
                                                            }`}
                                                    />
                                                </button>
                                            </div>
                                        </div>



                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="mb-6 p-5 pl-3 ml-5">
                                            <label className="block text-sm font-semibold mb-2 text-gray-700">
                                                Category<span className="text-red-500">*</span>
                                            </label>
                                            <Select
                                                isMulti
                                                name="categories"
                                                closeMenuOnSelect={false}
                                                options={staticCategories.map((cat) => ({ value: cat, label: cat }))}
                                                value={formData.categories?.map((c) => ({ value: c, label: c })) || []}
                                                onChange={(selected) =>
                                                    setFormData({
                                                        ...formData,
                                                        categories: selected.map((s) => s.value),
                                                    })
                                                }
                                                components={{ Option: OptionWithCheckbox }}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        border: "none",
                                                        borderBottom: "2px solid #ccc",
                                                        borderRadius: 0,
                                                        boxShadow: "none",
                                                        "&:hover": { borderBottom: "2px solid #3b82f6" },
                                                    }),
                                                }}
                                            />

                                            {errors.categories && (
                                                <p className="text-red-500 text-xs italic mt-2">{errors.categories}</p>
                                            )}
                                        </div>
                                        <div className="mb-6 p-5 pl-3 ml-5">
                                            <label className="block text-sm font-semibold mb-2 text-gray-700">
                                                Brand<span className="text-red-500">*</span>
                                            </label>
                                            <Select
                                                name="brand"
                                                isMulti={false}
                                                closeMenuOnSelect={true}
                                                options={brandeOptions.map((st) => ({
                                                    value: st.id,
                                                    label: st.name,
                                                }))}
                                                value={
                                                    formData.brand
                                                        ? brandeOptions.find((opt) => opt.value === formData.brand)
                                                        : null
                                                }
                                                onChange={(selected) =>
                                                    setFormData({
                                                        ...formData,
                                                        brand: selected ? selected.value : "",
                                                    })
                                                }
                                                className="basic-single-select w-full"
                                                classNamePrefix="select"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        border: "none",
                                                        borderBottom: "2px solid #ccc",
                                                        borderRadius: 0,
                                                        boxShadow: "none",
                                                        "&:hover": { borderBottom: "2px solid #3b82f6" },
                                                    }),

                                                }}
                                            />

                                            {errors.brand && (
                                                <p className="text-red-500 text-xs italic mt-2">{errors.brand}</p>
                                            )}
                                        </div>

                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="mb-6 p-5 pl-3 ml-5">
                                            <label
                                                htmlFor="assets_color_thumbnail"
                                                className="block text-sm font-semibold mb-2 text-gray-700"
                                            >
                                                Thumbnail: <span className="text-red-500">*</span>
                                            </label>

                                            <div className="flex items-center gap-6">
                                                {/* Left: Preview Image */}
                                                <div className="w-1/3">
                                                    {formData.assets_color_thumbnail ? (
                                                        <img
                                                            src={URL.createObjectURL(formData.assets_color_thumbnail)}
                                                            alt="Thumbnail Preview"
                                                            className="h-24 w-full object-contain rounded "
                                                        />
                                                    ) : formData.assets_color_thumbnail_path ? (
                                                        <img
                                                            src={formData.assets_color_thumbnail_path}
                                                            alt="Current Thumbnail"
                                                            className="h-24 w-full object-contain  rounded "
                                                        />
                                                    ) : (
                                                        <div className="h-24 w-full flex items-center justify-center border rounded bg-gray-100 text-gray-400 text-xs">
                                                            No Image
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Right: Upload Input */}
                                                <div className="flex-1">
                                                    <input
                                                        type="file"
                                                        accept=".png,.webp"
                                                        name="assets_color_thumbnail"
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, assets_color_thumbnail: e.target.files[0] })
                                                        }
                                                        className="block w-full py-2 px-1 text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                                                    />
                                                    {errors.assets_color_thumbnail && (
                                                        <p className="text-red-500 text-xs italic mt-2">
                                                            {errors.assets_color_thumbnail}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>


                                        <div className="mb-6 p-5 pl-3 ml-5">
                                            <label htmlFor="childCategory" className="block text-sm font-semibold mb-2 text-gray-700">
                                                Style Type<span className="text-red-500">*</span>
                                            </label>
                                            <Select
                                                id="styleType"
                                                name="styleType"
                                                isMulti={false}
                                                options={styleTypeOptions.map((st) => ({
                                                    value: st.id,
                                                    label: st.name,
                                                }))}
                                                value={
                                                    formData.visualizer_style_type_id
                                                        ? {
                                                            value: formData.visualizer_style_type_id,
                                                            label:
                                                                styleTypeOptions.find(
                                                                    (s) => s.id === formData.visualizer_style_type_id
                                                                )?.name || "",
                                                        }
                                                        : null
                                                }
                                                onChange={(selected) => {
                                                    handleStyleTypeSelect(selected ? selected.value : "");
                                                    setErrors({ ...errors, default_style_type_id: "" });
                                                }}
                                                className="basic-single w-full"
                                                classNamePrefix="select"
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        border: "none",
                                                        borderBottom: "2px solid #ccc",
                                                        borderRadius: 0,
                                                        boxShadow: "none",
                                                        minHeight: "42px",
                                                        "&:hover": { borderBottom: "2px solid #3b82f6" },
                                                    }),
                                                }}

                                            />
                                            {errors.visualizer_style_type_id && <p className="text-red-500 text-xs italic mt-2">{errors.visualizer_style_type_id}</p>}
                                        </div>

                                    </div>




                                </div>
                            </div>

                            <div className="flex justify-end gap-4 mt-6">
                                <button
                                    onClick={() => {
                                        setAddColorPopup(false)
                                        resetFormData();
                                    }
                                    }
                                    className="p-2 bg-red-500 text-white rounded hover:bg-red-700"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSubmitColorData}
                                    className="p-2 bg-green-500 text-white rounded hover:bg-green-700"
                                >
                                    Save
                                </button>

                                <button
                                    onClick={handleSubmitColorData}
                                    className="p-2 bg-green-500 text-white rounded hover:bg-green-700"
                                >
                                    Save & Re-render
                                </button>

                            </div>

                        </div>
                    </div>
                )}


                {/* OrderPOPUP */}
                {showCategorySelector && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-lg max-h-[90vh] overflow-auto">
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-lg font-semibold text-teal-600">Select a Visualizer Category</h2>
                                <button
                                    onClick={() => setShowCategorySelector(false)}
                                    className="text-gray-600 hover:text-gray-800"
                                >
                                    <IoMdClose size={22} />
                                </button>
                            </div>

                            <div className="grid grid-cols-1 gap-2">
                                <DragDropContext onDragEnd={handleDragEnd}>
                                    <Droppable droppableId="category-tabs" direction="vertical">
                                        {(provided) => (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                className="flex flex-col space-y-2 w-full"
                                            >
                                                {dragTabs.map((cat, index) => (
                                                    <Draggable
                                                        key={cat.category_id}
                                                        draggableId={String(cat.category_id)}
                                                        index={index}
                                                    >
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className="w-full flex items-center justify-between px-4 py-2 rounded text-sm font-medium shadow border transition bg-white cursor-move"
                                                            >
                                                                <span>
                                                                    {cat?.VisualizerMasterCategory?.name || `Category ${cat.category_id}`}
                                                                </span>

                                                                <button
                                                                    onClick={() => {
                                                                        setCategoryToDelete(cat.id); // or cat.category_id if that's your DB id
                                                                        setShowDeleteConfirm(true);
                                                                    }}
                                                                    className="ml-3 text-red-500 hover:text-red-700 text-lg"
                                                                    title="Remove category"
                                                                >
                                                                    &times;
                                                                </button>

                                                            </div>

                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>
                                </DragDropContext>



                            </div>
                            <hr className="border-gray-200 my-4" />

                            {dropdownOptions.length > 0 && (

                                <div className="mt-4">
                                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                                        Parent Categories
                                    </label>

                                    <select
                                        value={selectedDropdownCategoryId}
                                        onChange={(e) => setSelectedDropdownCategoryId(e.target.value)}
                                        className="w-full border border-gray-300 rounded px-3 py-2"
                                    >
                                        <option value="" disabled>Select parent category</option>
                                        {dropdownOptions.map((cat) => (
                                            <option key={cat.id} value={cat.id}>
                                                {cat.name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}


                            <div className="flex justify-end">
                                <button
                                    className="my-6 bg-teal-500 text-white px-4 py-2 rounded hover:bg-teal-600 transition"
                                    onClick={handleAddCategoryAPI}
                                    disabled={!selectedDropdownCategoryId}
                                >
                                    Add Category
                                </button>
                            </div>


                        </div>
                    </div>
                )}


                {/* IMAGE MODAL */}
                {isImageModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
                        <div className="relative bg-white p-4 rounded-lg shadow-lg max-w-3xl w-full">
                            <button
                                onClick={() => setIsImageModalOpen(false)}
                                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold"
                            >
                                &times;
                            </button>
                            <img
                                src={previewImage}
                                alt="Preview"
                                className="max-h-[80vh] w-auto mx-auto object-contain"
                            />
                        </div>
                    </div>
                )}

                {/* DELETE POPUP */}
                {showDeleteModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
                        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                            <h2 className="text-lg font-semibold text-gray-800 mb-4">
                                Are you sure you want to delete this color?
                            </h2>

                            <div className="flex justify-end gap-4">
                                <button
                                    onClick={() => setShowDeleteModal(false)}
                                    className="px-4 py-2 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={async () => {
                                        try {
                                            setDeleteLoading(true);
                                            const url = `${process.env.REACT_APP_API_URL}/visualizer/deletevisualizerassetcolor`;
                                            const response = await API(url, { id: colorToDelete }, token);

                                            if (response?.Result === 1) {
                                                toast.success('Color deleted successfully');
                                                await fetchVisualizerDetails();
                                            } else {
                                                toast.error('Failed to delete color');
                                            }
                                        } catch (err) {
                                            toast.error('Error deleting color');
                                            console.error(err);
                                        } finally {
                                            setShowDeleteModal(false);
                                            setDeleteLoading(false);
                                            setColorToDelete(null);
                                        }
                                    }}
                                    className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                                >
                                    Yes, Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )}


                {/* DELETE CATEGORY */}
                {showDeleteConfirm && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] max-w-sm">
                            <h2 className="text-lg font-semibold mb-4 text-gray-800">
                                Are you sure you want to remove this category?
                            </h2>
                            <div className="flex justify-end space-x-4">
                                <button
                                    onClick={() => setShowDeleteConfirm(false)}
                                    className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={async () => {
                                        try {
                                            const url = `${process.env.REACT_APP_API_URL}/visualizer/deletevisualizercategory`;

                                            const response = await API(url, { id: categoryToDelete }, token);

                                            if (response?.Result === 1) {
                                                toast.success("Category removed");
                                                setDragTabs((prev) =>
                                                    prev.filter((tab) => tab.id !== categoryToDelete)
                                                );
                                                setCategoryTabs((prev) =>
                                                    prev.filter((tab) => tab.id !== categoryToDelete)
                                                );
                                            } else {
                                                toast.error("Failed to delete category");
                                            }
                                        } catch (err) {
                                            console.error(err);
                                            toast.error("Something went wrong");
                                        } finally {
                                            setShowDeleteConfirm(false);
                                            setCategoryToDelete(null);
                                        }
                                    }}
                                    className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
                                >
                                    Yes, Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {showGallery && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                        <div className="bg-white rounded-lg shadow-lg w-[95%] h-[90%] flex">


                            {/* Left Sidebar - Filters */}
                            <div className="w-1/4 border-r bg-gray-50 p-6 overflow-y-auto">
                                <h2 className="text-xl font-bold mb-6 text-gray-800 border-b pb-2">Filters</h2>

                                {/* Categories */}
                                <div className="mb-8">
                                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                                        Categories
                                    </h3>
                                    <div className="flex flex-wrap gap-2">
                                        {staticCategories.map((cat, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() =>
                                                    setSelectedCategories((prev) =>
                                                        prev.includes(cat)
                                                            ? prev.filter((c) => c !== cat)
                                                            : [...prev, cat]
                                                    )
                                                }
                                                className={`px-3 py-1 rounded-full text-xs font-medium transition-all duration-200 ${selectedCategories.includes(cat)
                                                    ? "bg-blue-600 text-white shadow"
                                                    : "bg-white border text-gray-600 hover:bg-blue-50"
                                                    }`}
                                            >
                                                {cat}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                {/* Angles */}
                                <div>
                                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3 flex items-center gap-2">
                                        <span className="w-2 h-2rounded-full"></span>
                                        Angles
                                    </h3>
                                    <div className="flex flex-col gap-3">
                                        {["Angle 1", "Angle 2"].map((angle, idx) => (
                                            <label
                                                key={idx}
                                                className={`flex items-center gap-2 text-sm cursor-pointer rounded-md px-2 py-1 transition-all duration-200 ${selectedAngles.includes(angle)
                                                    ? "font-medium"
                                                    : "hover:bg-gray-100"
                                                    }`}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={selectedAngles.includes(angle)}
                                                    onChange={() => {
                                                        setSelectedAngles((prev) =>
                                                            prev.includes(angle)
                                                                ? prev.filter((a) => a !== angle)
                                                                : [...prev, angle]
                                                        );
                                                    }}
                                                    className=" rounded focus:ring-0"
                                                />
                                                {angle}
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>


                            {/* Right Content - Gallery */}
                            <div className="w-3/4 p-6 overflow-y-auto">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-lg font-semibold text-gray-800">Gallery</h2>
                                    <button
                                        onClick={() => setShowGallery(false)}
                                        className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                                    >
                                        Close
                                    </button>
                                </div>

                                {/* Image Grid */}
                                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                                    {galleryImages
                                        .filter((img) => {
                                            const catMatch =
                                                selectedCategories.length === 0 ||
                                                selectedCategories.some((c) => img.categories.includes(c));
                                            const angleMatch =
                                                selectedAngles.length === 0 ||
                                                selectedAngles.some((a) => img.angles.includes(a));
                                            return catMatch && angleMatch;
                                        })
                                        .map((img, idx) => (
                                            <div
                                                key={idx}
                                                className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md cursor-pointer"
                                            >
                                                <img
                                                    src={img.url}
                                                    alt={`Gallery ${idx}`}
                                                    className="w-full h-32 object-contain bg-gray-50"
                                                />
                                                <p className="text-center text-sm mt-2 text-gray-700 px-2 break-words">
                                                    {img.name[0]}
                                                </p>

                                            </div>
                                        ))}
                                </div>



                            </div>
                        </div>
                    </div>
                )}




            </div >
        </>
    );
};

export default DetailsAgain;
